import React from 'react';
import styles from './BotScript.module.scss';
import { useParams } from 'react-router-dom';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Button from 'component/atom/forms/button/Button';
import { useToast } from 'app-context/toasterContext/ToastContext';
import Header from 'component/layout/header/Header';
import { scriptEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { botToast } from 'helpers/toastMessages';
import Loader from 'component/atom/loader/Loader';

const BotScript = () => {
  const { id } = useParams();
  const toast = useToast();

  const {
    data,
    isFetching,
    refetch: refetchUser,
  } = useFetch(['botScript', id], scriptEndpoints?.getBotScript(id));

  const handleCopy = () => {
    navigator.clipboard.writeText(data?.data?.script);
    toast.open(botToast.copy, 'add');
  };

  return (
    <div>
      <Header title="Bot Script" />
      {isFetching ? (
        <Loader isComponent />
      ) : (
        <div className={styles.cont}>
          <TextArea
            value={data?.data?.script}
            label="Script"
            disabled
            rows="18"
          />
          <div className={styles.buttonCont}>
            <Button label="Copy Embedded Code" onClick={handleCopy} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BotScript;
